export const quote = (text: string): string => {
  return `“${text}”`;
};

type JoiningWord = 'and' | 'or';

export const joinWords = (items: string[], word: JoiningWord): string => {
  if (items.length <= 1) return items.join('');
  return `${items.slice(0, -1).join(', ')} ${word} ${items.at(-1)}`;
};

const LONGEST_NAME = 40;

export const named = (text: string, fallback: string): string => {
  const line = text.trim().split('\n')[0]?.trim() ?? '';
  if (!line) return fallback;
  return quote(line.length > LONGEST_NAME ? `${line.slice(0, LONGEST_NAME - 1).trimEnd()}…` : line);
};

type NamedElement =
  { kind: 'field'; label: string } | { kind: 'section'; title: string } | { kind: 'staticText'; text: string };

export const elementName = (element: NamedElement): string => {
  if (element.kind === 'field') return named(element.label, 'an untitled field');
  if (element.kind === 'section') return named(element.title, 'an untitled section');
  return named(element.text, 'an empty text');
};
